import React, { useState, useCallback } from "react";
import { observer } from "mobx-react-lite";
import { useHistory } from "react-router-dom";
import { useMst } from "../../../../../mobx";
import { AccountCircle, ExitToApp, Settings } from "@mui/icons-material";
import { IconButton, ListItemIcon, MenuItem, ListItemText, Divider, Menu } from "@mui/material";
import { DefaultRoutes } from "../../../../../routes";

export default observer(function () {
  const history = useHistory();
  const { authStore } = useMst();
  const { logout, authenticatedUserId } = authStore;
  const [profileAnchor, setProfileAnchor] = useState(null);

  const handleOpen = useCallback(
    (e) => {
      setProfileAnchor(e.currentTarget);
    },
    [setProfileAnchor]
  );

  const handleClose = useCallback(() => {
    setProfileAnchor(null);
  }, [setProfileAnchor]);

  return (
    <>
      <IconButton color="inherit" onClick={handleOpen}>
        <AccountCircle />
      </IconButton>
      {renderMenu()}
    </>
  );

  function renderMenu() {
    return (
      <Menu
        anchorEl={profileAnchor}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
        keepMounted
        open={Boolean(profileAnchor)}
        onClose={handleClose}
      >
        <MenuItem onClick={onSettings} disabled={!authenticatedUserId}>
          <ListItemIcon>
            <Settings />
          </ListItemIcon>
          <ListItemText>Настройки</ListItemText>
        </MenuItem>
        <Divider />
        <MenuItem onClick={onLogout}>
          <ListItemIcon>
            <ExitToApp />
          </ListItemIcon>
          <ListItemText>Выйти</ListItemText>
        </MenuItem>
      </Menu>
    );
  }

  function onSettings() {
    handleClose();
    history.push(`/${DefaultRoutes.user}/${authenticatedUserId}`);
  }

  function onLogout() {
    handleClose();
    logout();
  }
});
